import { Button, Sheet, Tag, TextStyle } from '@superops/ui-design-system';
import { cloneDeep, isEmpty } from 'lodash';
import {
  getTranslatedText,
  ENTITY_MAP,
  withErrorBoundary
} from '@nile/components';
import React, { useCallback, useState } from 'react';
import { SelectionSheet } from '@nile/reports/src/modules/component';
import { FormattedMessage } from 'react-intl';

function ColumnSelector(props) {
  const {
    data = [],
    updateData,
    intl,
    meta,
    selectedModule,
    errors = null
  } = props;

  const [sheetActive, setSheetActive] = useState(false);
  const toggleSheetActive = useCallback(
    () => setSheetActive((sheetActive) => !sheetActive),
    []
  );

  const removeColumn = (val) => {
    const columns = cloneDeep(data.selectAttributes);
    const updatedColumn = columns.filter((el) => el !== val);
    updateData('reportData', { ...data, selectAttributes: updatedColumn });
  };
  const updateParent = (selectedItem) => {
    const selectedColumn = selectedItem.map((el) => el.name);
    updateData('reportData', { ...data, selectAttributes: selectedColumn });
  };

  const getFilteredMeta = () => {
    const currentModuleMeta = selectedModule?.[0]?.meta?.attributeGroups || [];

    const getModuleName = (module, entity) => {
      switch (true) {
        case (module == 'user' || module == 'requester') &&
          entity == 'RequesterAssociation':
          return 'clientuser';
        default:
          return module;
      }
    };

    const getEntityAttr = (obj, module, parentModule) => {
      const moduleName = getModuleName(module, data?.entity);
      const metaAttr = meta.filter(
        (mt) => mt.name === ENTITY_MAP[moduleName]
      )?.[0]?.attributes;
      const metaData = metaAttr?.find((att) => att.name === obj);
      return {
        ...metaData,
        value:
          module === data?.entity?.toLowerCase()
            ? obj
            : `${parentModule}.${obj}`
      };
    };

    const getAttributeName = (
      attr,
      module = data?.entity?.toLowerCase(),
      parentModule = ''
    ) => {
      return attr
        .map((fld) =>
          fld?.attributes
            ? getAttributeName(
                fld?.attributes,
                fld?.name,
                parentModule.length ? `${parentModule}.${fld?.name}` : fld?.name
              )
            : getEntityAttr(fld?.name, module, parentModule)
        )
        .flat();
    };
    const allEnt = currentModuleMeta.map((el) => ({
      ...el,
      attributes: getAttributeName(el.attributes)
    }));

    return allEnt;
  };

  const alteredMeta = getFilteredMeta();

  const alteredMetaAttr = alteredMeta.map((el) => el.attributes).flat();

  const getLabel = (el) => {
    const slectedEl = alteredMetaAttr.find((att) => att.value === el);
    const label = slectedEl?.attributePlaceHolder?.label;
    if (label) {
      switch (label) {
        case 'entityAttribute.project.owner.name':
          return getTranslatedText(intl, 'entityAttribute.requester.name');
        default:
          return getTranslatedText(intl, label);
      }
    }
    return el;
  };

  const getColumnLabel = (attr) => {
    if (attr?.isCustom) {
      return attr?.attributePlaceHolder?.label;
    }
    if (attr?.attributePlaceHolder?.label) {
      const label = attr?.attributePlaceHolder?.label;
      switch (label) {
        case 'entityAttribute.project.owner.name':
          return getTranslatedText(intl, 'entityAttribute.requester.name');
        default:
          return getTranslatedText(intl, attr?.attributePlaceHolder?.label);
      }
    }
    return attr?.value;
  };

  return (
    <>
      <div className="mb10 uppercase ">
        <TextStyle weight="Bold">
          <FormattedMessage id="common.lable.displayColumn" />
        </TextStyle>
      </div>
      {!isEmpty(data.selectAttributes) && (
        <div className="flex wrap mbt15">
          {data.selectAttributes?.map((el) => (
            <div className="m8">
              <Tag onRemove={() => removeColumn(el)}>{getLabel(el)}</Tag>
            </div>
          ))}
        </div>
      )}
      {errors && errors?.selectAttributes && (
        <TextStyle variation="negative">
          {errors?.selectAttributes[0]}
        </TextStyle>
      )}
      <div className="mbt5">
        <Button plain onClick={toggleSheetActive}>
          <FormattedMessage id="reports.datareport.columns.addmorecolumn" />
        </Button>
        <Sheet open={sheetActive} onClose={toggleSheetActive}>
          <SelectionSheet
            canReorder
            sections={alteredMeta?.map((el) => ({
              header: getTranslatedText(intl, el.label),
              id: el.constant,
              items: el.attributes?.map((attr) => ({
                name: attr?.value,
                id: attr?.value,
                label: getColumnLabel(attr)
              })),
              name: getTranslatedText(intl, el.label)
            }))}
            updateParent={updateParent}
            meta={{
              heading: getTranslatedText(
                intl,
                'reports.datareport.columns.addmore.sheet.title'
              )
            }}
            selectedItems={data.selectAttributes?.map((attr) => ({
              name: attr,
              id: attr,
              label: getLabel(attr)
            }))}
            toggleSheetActive={toggleSheetActive}
          />
        </Sheet>
      </div>
    </>
  );
}

export default withErrorBoundary(ColumnSelector);
